
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('g',{attrs:{"fill":"none","transform":"translate(1 1)"}},[_c('rect',{attrs:{"width":"21","height":"19","x":".5","y":"3.167","stroke":"#FFF","rx":"3"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 8V7h22v1z"}}),_c('g',{attrs:{"stroke":"#FFF","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M11 11v4M14.62 17.615l-3.593-2.406"}})]),_c('path',{attrs:{"stroke":"#FFF","stroke-linecap":"round","d":"M5 .667v4.666M17 .667v4.666"}})])])
      }
    
      }
    